import { IUser } from '@frontend/user/types';

import { NotificationPreferences } from '../../modal/contact-detail-modal/notification-preferences/notification-preferences.component';
import { UserGroupCard } from '../../user/modal/user-group-card/user-group-card.component';
import { LinksCard } from '../links-card/links-card.component';
import { UserDetailsCard } from './user-details-card/user-details-card.component';
import { ValidLicensesCard } from './valid-licenses-card/valid-licenses-card.component';

interface GeneralTabProps {
    user: IUser;
    privacyDocumentFile?: { blob: Blob; url: string } | null;
}

const GeneralTab = ({ user, privacyDocumentFile }: GeneralTabProps) => {
    return (
        <div className='flex w-full flex-col gap-6 md:flex-row'>
            <div className='flex flex-1 flex-col gap-4'>
                <UserDetailsCard user={user} />
                <NotificationPreferences object={user} />
            </div>
            <div className='flex w-full flex-col gap-4 md:w-96'>
                <UserGroupCard entity_id={user.id} />
                <ValidLicensesCard userId={user.id} />
                <LinksCard privacyDocumentFile={privacyDocumentFile} />
            </div>
        </div>
    );
};

export default GeneralTab;
